import styled from 'styled-components';

import { Collapse, InnerCollapse } from '../../../components/index';

export const DockingsCollapse = styled(Collapse)`
  & .ant-collapse-item {
    margin-block-start: 24px;
    border: 1px solid var(--neutral_lighter);

    & .ant-collapse-header {
      display: flex;
      flex-direction: row;
      background: var(--neutral_lightest);
      font-size: 16px;
      color: var(--neutral_medium) !important;
      padding-left: 16px !important;
      /* & .ant-collapse-header-text {
      } */
      & .docking-header-title {
        display: flex;
        flex-direction: row;
        column-gap: 10px;
        align-items: end;

        & .docking-title {
          font-size: 16px;
          font-weight: 700;
          line-height: 24px;
        }

        & .docking-code {
          font-family: Consolas;
          font-weight: normal;
          font-size: 14px;
          display: inline-block;
        }
      }
    }
  }
`;

/**
 * O bloco de eventos: "Agora e próximas" ou "Histórico".
 *
 * O cabeçalho carrega o título e a contagem, e é o que o operador clica para
 * abrir ou fechar o bloco. Quem nasce aberto e quem nasce colapsado é decisão
 * de quem monta o bloco, não deste estilo.
 */
export const DockingEventBlockCollapse = styled(InnerCollapse)`
  border: 1px solid var(--neutral_lighter);
  margin-block-start: 16px;

  & > .ant-collapse-item > .ant-collapse-header {
    background: #fff;
    font-size: 14px;
    font-weight: 700;

    &:hover {
      background: var(--neutral_lightest);
    }

    & .docking-block-title {
      align-items: center;
      display: flex;
    }
  }

  & > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
    padding: 16px;
  }
`;

/**
 * A lista de itens de um bloco.
 *
 * Além do tipo e do número, o cabeçalho de cada item carrega o berço, a data
 * que o posiciona na ordem e, quando for o caso, o marcador de em andamento.
 * São muitos campos numa linha, então ela quebra em vez de espremer, e os
 * campos ausentes viram texto explícito, nunca espaço vazio.
 */
export const DockingItemsCollapse = styled(InnerCollapse)`
  & .ant-collapse-item > .ant-collapse-header {
    & .docking-header-title {
      flex-wrap: wrap;
      row-gap: 4px;

      & .docking-berth,
      & .docking-event-date {
        font-weight: normal;
        font-size: 14px;
        line-height: 24px;
        white-space: nowrap;
      }

      & .docking-event-date {
        &.expected {
          color: var(--predicted-docking);
        }
        &.absent {
          color: var(--neutral_light);
          font-style: italic;
        }
      }

      & .docking-berth.absent {
        color: var(--neutral_light);
        font-style: italic;
      }

      & .docking-in-progress {
        background: var(--success-lightest);
        border: 1px solid var(--success-medium);
        border-radius: 100px;
        color: var(--success-dark);
        font-size: 12px;
        font-weight: 700;
        line-height: 18px;
        padding: 1px 10px;
        text-transform: uppercase;
        white-space: nowrap;
      }
    }
  }
`;

export const DockingItemsLoading = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;

  & .docking-item-loading {
    align-items: center;
    border: 1px solid var(--neutral_lighter);
    display: flex;
    min-height: 48px;
    padding: 0 16px;

    & .ant-skeleton {
      width: 100%;
    }

    & .ant-skeleton-paragraph {
      margin: 0;
    }
  }
`;

export const ContainerProductDescription = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid var(--neutral_lighter);
  padding: 16px;

  hr {
    border: none;
    border-top: 1px dashed var(--neutral_light);
    height: 1px;
    width: 100%;
    margin-bottom: 16px;
  }
`;

export const TitleEdit = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: baseline;
`;
